﻿import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';

import { User } from '../_models/user';
import { MoghimCore2010Proxy } from '@core/proxies/MoghimCore2010Proxy';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
    private currentUserSubject: BehaviorSubject<User>;
    public currentUser: Observable<User>;

    constructor(private http: HttpClient) {
        this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(sessionStorage.getItem('_m_user')));
        this.currentUser = this.currentUserSubject.asObservable();
    }

    public get currentUserValue(): User {
        return this.currentUserSubject.value;
    }

    setUser(model) {
        sessionStorage.setItem('_m_user', JSON.stringify(model));
        this.currentUserSubject.next(model);
    }

    login(username: string, password: string, customer) {
        
        let proxy = new MoghimCore2010Proxy(this.http);
        let _login = proxy.AgencyLogin({customerCode:customer, username:username, password:password});
        
        _login.subscribe(
            user => {
                if (user) {
                    user.model['agency'] = customer;
                    if (customer == 100) user.model['baseUrl'] = "http://164.215.128.29/moghimagencyServices";
                    this.setUser(user.model);
                } else this.currentUserSubject.next(null);
                return user;
            },
            reject => {
                console.log('authError',reject);
            }
        )
        return _login;
    }

    logout() {
        sessionStorage.removeItem('_m_user');
        this.currentUserSubject.next(null);
        // this.currentUser = this.currentUserSubject.asObservable();
        // this.router.navigate(['/']);
    }
}